import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Segment } from 'semantic-ui-react'
import { date as dateFormatter } from 'loankeeper-common/helpers/formatters'
//@ts-ignore
import { SegmentGroup, FlexTableChild, TableContainer } from 'shared/StyledComponents'
//@ts-ignore
import LKGrid from 'shared/LKGrid'
//@ts-ignore
import withConstantPermissions from 'shared/containers/withConstantPermissions'
//@ts-ignore
import KeyHandler from 'shared/KeyHandler'
import { translateCmd, translateBase, icon } from '../helpers'
import { formName } from '../constants'
import { constants as DCConstants } from '../../DetailsContainer'
import { actions as LKModalActions } from '../../shared/LKModal'
import { AccountTabProps, AccountTabState, AccountArrayObj } from '../types'
const config = {
  gridIdentity: { formName, objectName: 'dbgrd_accounts' },
  syncGridState: true,
  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableSorting: true,
  enableRowSelection: true,
  columnConfigs: {
    BalCode: { cellStyle: { textAlign: 'right' } },
    OpenDate: { valueFormatter: ({ value }) => dateFormatter(value) },
    CloseDate: { valueFormatter: ({ value }) => dateFormatter(value) },
  },
}

@withRouter
@withConstantPermissions('ACC_ACCOUNT_LIST as CanView')
//@ts-ignore
@connect(undefined, {
  closeModalAction: LKModalActions.close,
})
class Accounts extends React.Component<AccountTabProps, AccountTabState>  {
  state = {
    hasKeyHandler: false,
  }

  pushDetailsRoute = ({ ID, HashSum_AccountID_ }: AccountArrayObj) =>
    this.props.history.push(`/secure/account/${ID}/details/${HashSum_AccountID_}`)

  pushStatementRoute = ({ ID, HashSum_AccountID_ }: AccountArrayObj) =>
    this.props.history.push(`/secure/account/${ID}/statement/${HashSum_AccountID_}`)

  onRowDoubleClicked = ({ node: { data } }: {node: {data: AccountArrayObj}}) => {
    if (this.props.CanView) this.pushDetailsRoute(data)
  }

  getContextMenuItems = (params: {node: {data: AccountArrayObj}}) => {
    const {
      node: { data },
    } = params
    return [
      {
        name: translateCmd('view_account'),
        action: () => this.showAcc(data),
        icon: 'info',
        permissionKey: 'ACC_ACCOUNT_LIST',
      },
      this.props.CanView
        ? {
            name: translateCmd('acc_statement'),
            action: () => this.pushStatementRoute(data),
            icon: 'transactions',
            permissionKey: 'ACC_STATEMENT_VIEW',
          }
        : undefined,
      'excelExport',
    ].filter((x) => x !== undefined)
  }

  showAcc = (data: AccountArrayObj) => {
    this.pushDetailsRoute(data)

    this.setState({ hasKeyHandler: true })
  }

  handleEscKey = () => {
    this.props.closeModalAction('ClientDetailsInPawnshop')

    this.setState({ hasKeyHandler: false })
  }

  render() {
    const { hasKeyHandler } = this.state
    const { data, ID } = this.props
    const LKGridInstanceName = `${DCConstants.DetailsGridPrefixes.client}-${ID}-Accounts`
    return (
      <SegmentGroup>
        <Segment.Group>
          <FlexTableChild>
            <TableContainer>
              {hasKeyHandler && <KeyHandler targetKey="27" onKey={this.handleEscKey} />}
              <LKGrid
                rowData={data}
                {...config}
                onRowDoubleClicked={this.onRowDoubleClicked}
                getContextMenuItems={this.getContextMenuItems}
                instanceName={LKGridInstanceName}
              />
            </TableContainer>
          </FlexTableChild>
        </Segment.Group>
      </SegmentGroup>
    )
  }
}

//@ts-ignore
Accounts.config = {
  title: () => translateBase('tb_accounts'),
  name: 'accounts',
  component: Accounts,
  api: 'accounts',
  icon: icon('tb_accounts'),
}
//@ts-ignore
Accounts.defaultProps = {
  data: [],
}

export default Accounts
